module.exports = "https://static.wanderu.com/static/media/more.b7368e56.svg";